import React from 'react';

import Input from '../forms/Input'

export default class SortFilterBar extends React.PureComponent {

    static defaultProps = {
        handleSearch: (val) => console.warn("Can't search for " + val + " because handle search props isn't implemented"),
        filterOptions: [],
    }


    constructor(props) {
        super(props);

        this.state = {
            searchVal: '',
            hasSearched: 0,
        }

        this.searchTimeout = null;
    }

    render() {
        return (
            <div className={'my-6'}>
                <nav className={'level'}>
                    <div className={'level-left'}>
                        {this.props.filterOptions.map(d => (
                            <Input
                                type={'select'}
                                options={d.options}
                                onChange={d.onChange}
                                value={d.value}
                                label={d.label}
                            />
                        ))}
                    </div>
                    <div className={'level-right'}>
                        <div className={'level-item'}>
                            <form onSubmit={(ev) => {
                                ev.preventDefault();
                                this.props.handleSearch(this.state.searchVal);
                                this.setState({hasSearched: 1})
                            }}
                          >
                            <Input
                                type={'text'}
                                value={this.state.searchVal}
                                onChange={val => {
                                    this.setState({searchVal: val});
                                    if (!(val || val.length) && this.state.hasSearched) {
                                        this.props.handleSearch('');
                                        this.setState({hasSearched: 0});
                                    }
                                }}
                                addOns={[
                                    <div className="control">
                                        <button type={'submit'} className="button is-info" onClick={() => {
                                            this.props.handleSearch(this.state.searchVal);
                                            this.setState({hasSearched: 1})
                                        }}>
                                            Search
                                        </button>
                                    </div>
                                ]}
                            />
                            </form>
                        </div>
                    </div>
                </nav>
            </div>
        )
    }

}
